/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */
export const GET_CATEGORIES = "GET_CATEGORIES";
export const SET_SECOND_COMPONENT_FLOW = "SET_SECOND_COMPONENT_FLOW";
export const SET_USE_SECOND_VIEW = "SET_USE_SECOND_VIEW";
export const SET_IMAGE_CATEGORY = "SET_IMAGE_CATEGORY";
export const SET_SELECTED_IMAGE = "SET_SELECTED_IMAGE";
export const CLEAR_COMPONENT_SELECTED_IMAGE = "CLEAR_COMPONENT_SELECTED_IMAGE";
export const CLEAR_SELECTED_IMAGES = "CLEAR_SELECTED_IMAGES";
export const SET_COMPONENT_CURRENT_IMAGE = "SET_COMPONENT_CURRENT_IMAGE";
export const SET_LIBRARY_RECIPE = "SET_LIBRARY_RECIPE";
export const UPDATE_LIBRARY_COMPONENT = "UPDATE_LIBRARY_COMPONENT";
export const SET_VIEWS = "SET_VIEWS";
export const SET_ACTIVE_VIEW = "SET_ACTIVE_VIEW";
export const PREV_VIEW = "PREV_VIEW";
export const NEXT_VIEW = "NEXT_VIEW";
export const RESET_NAVIGATION = "RESET_NAVIGATION";
export const SET_IS_BACK_APPLIED = "SET_IS_BACK_APPLIED";
export const SET_CURRENT_UGC_VIEW = "SET_CURRENT_UGC_VIEW";
export const SET_USE_SAME_IMAGE = "SET_USE_SAME_IMAGE";
